import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  resetForgotPasswordForm: null,
  updateForgotPasswordField: ['field'],
  updateConfirmationCode: ['field'],
});

export const ForgotPasswordFormTypes = Types;
export default Creators;
